
import React from 'react';

export const UserCircleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    account_circle
  </span>
);